<template>
    <div>
      <div class="d-flex justify-center" v-if="loadState.isLoading||loading">   
          <v-progress-circular
          indeterminate
          color="primary"
          size="16"
          width="1"
        ></v-progress-circular>    
      </div> 
      <div v-else class="action-btns">
        <v-btn v-if="misDesktopOnline&&typeof item.medRecordTemplate === 'undefined'" icon x-small @click.stop="misDesktopOpenFile(item)">
          <v-icon small title="Открыть локально">mdi-open-in-new</v-icon>
        </v-btn>

        <v-btn icon x-small @click.stop="downloadAction(item)">
          <v-icon small title="Скачать">mdi-download</v-icon>
        </v-btn>

        <v-btn icon x-small @click.stop="typeof item.medRecordTemplate !== 'undefined' ? preview(item) : $emit('mediaPreview',item.id)">
          <v-icon small title="Предпросмотр">mdi-eye</v-icon>
        </v-btn>

        <v-btn :class="[item.isPrinted ? 'btnSuccessIco btnSuccessIco_dark btnSuccessIco_small' : '']" icon x-small @click.stop="print(item)">
          <v-icon small title="Печать">mdi-printer</v-icon>
        </v-btn>

        <btn-small-icon-accept :btnClass="[item.isSent ? 'btnSuccessIco btnSuccessIco_dark btnSuccessIco_small' : '']" text="Отправить на E-mail?" icon="mdi-email-arrow-right" @accept="sendEmail(item)"/>
        
        <btn-small-icon-accept v-if="item.medRecordTemplate !== undefined" text="Создать копию?" icon="mdi-content-copy" @accept="copyAction(item)"/>   

        <btn-small-icon-accept text="Удалить?" icon="mdi-delete" @accept="deleteAction(item)" />
        
      </div>

      <dialog-editor :item.sync="previewState.isModalOpen" fullscreen footer-hide content-padding-remove :name="item.name!=null&&item.name!='' ? item.name : item.medRecordTemplate.name" :color="$mainColor">
        <v-card class="grey lighten-4">
          <div>
            <iframe
                :src="previewState.modalData?.previewUrl"
                frameBorder="0"
                :style="'width:'+previewWidth+'px;height:'+previewHeight+'px'"
            ></iframe>
          </div>
        </v-card> 
      </dialog-editor>
    </div>
</template>

<script>
import Api from "@/Api";
import axios from "axios";
import State from "@/plugins/state";
import printJS from "print-js";
import BtnSmallIconAccept from "@/componentsV2/base/BtnSmallIconAccept.vue";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";

export default {
  components: {
    BtnSmallIconAccept,
    DialogEditor
  },
  props: [
    'item','loading'
  ],
  data: () => ({
    loadState: new State(),
    previewState: new State(),
    previewWidth:0,
    previewHeight:0,
    misDesktopOnline:false,
  }),
  mounted(){
    this.$tools.misDesktopStatus((v)=>{
      this.misDesktopOnline = v;
    });
  },
  methods: {
    misDesktopOpenFile(v){
      axios.get(Api.host + '/media/media/' + v.id + '/').then(r1 => {
        let mediaData = r1.data;
        this.$tools.misDesktopOpenFile(
            mediaData.path,
            mediaData.name + mediaData.path.substring(mediaData.path.lastIndexOf('.')),
            "https://"+window.location.hostname+"/api/media/media/upload/desktop/",
            {
              id: v.id,
            },
            ()=>{
              this.$store.commit('alertSuccess', 'Файл открывается локально');
            }, ()=>{
              this.$store.commit('alertError', 'Не удалось открыть файл локально');
            }
        );
      });
    },
    downloadAction(item){
      this.loadState.stateLoading();
      function download(href,name) {
        const a = document.createElement('a');
        a.href = href;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      if (typeof item.medRecordTemplate!=='undefined') {
        let name = item.name!==null ? item.name : item.medRecordTemplate.name;
        Api.service.medRecord.medRecordDownload(item.id, (data)=>{
          for(let index in data){
            download(data[index],name+' ('+this.$tools.userFullName(item.user)+')'+'.docx')
            this.loadState.stateSuccess();
          }
        });
      }  else {
        let fileExtension = item.path.substring(item.path.lastIndexOf('.'))
        download(item.path,item.name+' ('+this.$tools.userFullName(item.user)+')'+fileExtension )
        this.loadState.stateSuccess();
      }
    },
    preview(item) {
      this.previewState.stateLoading();
      this.previewWidth = window.innerWidth;
      this.previewHeight = window.innerHeight-64;

      Api.service.medRecord.medRecordDownload(item.id, (data)=>{
        for(let index in data){
          let obj = item;
          obj.previewUrl = 'https://view.officeapps.live.com/op/embed.aspx?src='+data[index];
          console.log(obj)
          this.previewState.modalOpen(obj);
        
        }
        this.previewState.stateSuccess();
      });
    },
    print(item){
      this.loadState.stateLoading();
      if (typeof item.medRecordTemplate!=='undefined') {
        axios.get(Api.host+`/medRecord/medRecord/${item.id}/preview/`)
        .then(r=>{
          let images = [];
          r.data.forEach(v=>{
            images.push(v);
          });
          printJS({ printable: images, type: 'image', header: ''});
          this.loadState.stateSuccess();
          this.$emit('load')
        }).catch(e=>{
          console.log(e);
          this.loadState.stateError(e.response.data.errors);
        });
      }else {
        Api.service.media.mediaPreview(item.id,'isPrinted', (data)=>{
          let images = [];
          data.forEach((v)=>{
            images.push(v);
          });
          printJS({ printable: images, type: 'image', header: ''});
          this.loadState.stateSuccess();
          this.$emit('load')
        });
      }  
    },
    sendEmail(item){
      this.loadState.stateLoading();
      if (typeof item.medRecordTemplate!=='undefined') {
        Api.service.medRecord.medRecordEmailSend(item.id, ()=>{
          this.loadState.stateSuccess();
          this.loadState.modalClose();
          this.$store.commit('alertSuccess', 'Успешно отправлено');
          this.$emit('load')
        }, ()=>{
          this.loadState.stateSuccess();
          this.loadState.modalClose();
          this.$emit('load')
        });
      } else {
        Api.service.media.mediaEmailSend(item.id, ()=>{
          this.loadState.stateSuccess();
          this.loadState.modalClose();
          this.$store.commit('alertSuccess', 'Успешно отправлено');
          this.$emit('load')
        }, ()=>{
          this.loadState.stateSuccess();
          this.loadState.modalClose();
          this.$emit('load')
        });
      }  
    },
    deleteAction(item){
      this.loadState.stateLoading();
      if (typeof item.medRecordTemplate!=='undefined') {
        Api.service.medRecord.medRecordDelete(item.id, ()=>{
          this.loadState.stateSuccess();
          this.$emit('load')
        });
      } else {
        Api.service.media.mediaDelete(item.id, ()=>{
          this.loadState.stateSuccess();
          this.$emit('load')
        });
      } 
    },
    copyAction(item){
      this.loadState.stateLoading();
      Api.service.medRecord.medRecordCopy(item.id, ()=>{
        this.loadState.stateSuccess();
        this.$store.commit('alertSuccess', 'Успешно скопировано');
        this.$emit('load')
      });
    },
    
  },
}
</script>

<style lang="scss" scoped>
  .action-btns {
    display: flex;
    gap: 10px;
  }
</style>